export default __webpack_public_path__ + "c180ed6d211600a4b87b7130eab24d52.svg";